<div class="content">
  <h1>{{ getClientName() }}</h1>
  <app-reports-panel [reportsService]="reportsService">
  </app-reports-panel>
</div>
